// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R7tJ7","icon":"styles_icon__1Xc5W"};